import fetch from 'isomorphic-fetch'
import * as types from '../constants/ActionTypes'
import * as general from '../constants/General'
import * as resource from '../constants/Resources'
import * as type from '../constants/Types'
import * as dataActions from './dataActions'

function setGroupUnsafe(id) {
  return {
    type: types.SET_LAYOUT,
    id
  }
}

export function setGroup(id) {
  return (dispatch) => {
    dispatch(setGroupUnsafe(id))
  }
}

function setDefaultPageUnsafe(id) {
  return {
    type: types.SET_DEFAULT_PAGE,
    id
  }
}

export function setDefaultPage(id) {
  return (dispatch) => {
    dispatch(setDefaultPageUnsafe(id))
  }
}

export function setClosePage(id) {
  return (dispatch) => {
    dispatch(setClosePageUnsafe(id))
  }
}

function setClosePageUnsafe(id) {
  return {
    type: types.SET_CLOSE_PAGE,
    id
  }
}

export function receiveLayouts(pos, json) {
  return {
    type: types.RECEIVE_LAYOUTS,
    pos,
    layouts: json,
    receivedAt: Date.now()
  }
}

function fetchLayouts(pos) {
  return dispatch => {
    const apiUrl = `${general.API_URL_LAYOUTITEMS}${pos}`;
    return fetch(apiUrl)
      .then(response => response.json())
      .then(json => dispatch(receiveLayouts(pos, json)));
  }
}

export function getLayouts() {
  return (dispatch, getState) => dispatch(fetchLayouts(getState().generalState.posId))
}

function getFunctionBarButtons(functionbartype) {
  return (dispatch, getState) => {
    const functionbarbuttons = [];
    let buttonColor = '#63b65e';

    switch (functionbartype) {
      case general.FUNCTIONBAR_STATUS:
        getState().generalState.devices.map((device) => {
          if (device.devicetype === 600) {
            return '';
          }
          buttonColor = '#63b65e';
          if (device.status > status.PRINTER_OK) {
            buttonColor = '#ff6160'
          }
          let buttonType = general.FUNCTIONBAR_STATUS_PRINTER;
          let itemid = device.deviceid;
          if (device.devicetype === type.DEVICE_DRAWER) {
            buttonType = general.FUNCTIONBAR_STATUS_DRAWER;
            itemid = device.posdevicelinkid;
          } else if (device.devicetype === type.DEVICE_SCALE) {
            buttonType = general.FUNCTIONBAR_STATUS_SCALE;
          }

          functionbarbuttons.push({
            description: device.description,
            color: buttonColor,
            type: buttonType,
            itemid: itemid,
            itemparam: device.devicecontroller,
            status: device.status,
            statusmessage: device.statusmsg
          })
          return ''
        })
        break;
      case general.FUNCTIONBAR_FUNCTION:
        functionbarbuttons.push({
          description: dispatch(dataActions.getTranslation(resource.Z_REPORT)),
          color: buttonColor,
          type: general.FUNCTIONBAR_FUNCTION_ZREPORT,
          itemid: 1,
          itemparam: '',
          status: 100,
          statusmessage: ''
        })
        functionbarbuttons.push({
          description: dispatch(dataActions.getTranslation(resource.X_REPORT)),
          color: buttonColor,
          type: general.FUNCTIONBAR_FUNCTION_XREPORT,
          itemid: 2,
          itemparam: '',
          status: 100,
          statusmessage: ''
        })
        functionbarbuttons.push({
          description: dispatch(dataActions.getTranslation(resource.X_REPORT_ALL)),
          color: buttonColor,
          type: general.FUNCTIONBAR_FUNCTION_XREPORT,
          itemid: 3,
          itemparam: '',
          status: 100,
          statusmessage: ''
        })       
        if (getState().generalState.licenses.blackbox && getState().generalState.hasBlackbox) {
          functionbarbuttons.push({
            description: 'X-informatief',
            color: buttonColor,
            type: general.FUNCTIONBAR_FUNCTION_XINFOREPORT,
            itemid: 4,
            itemparam: '',
            status: 100,
            statusmessage: ''
          });
          functionbarbuttons.push({
            description: dispatch(dataActions.getTranslation(resource.WORK_IN)),
            color: buttonColor,
            type: general.FUNCTIONBAR_FUNCTION_WORKIN,
            itemid: 6,
            itemparam: '',
            status: 100,
            statusmessage: ''
          });
          functionbarbuttons.push({
            description: dispatch(dataActions.getTranslation(resource.WORK_OUT)),
            color: buttonColor,
            type: general.FUNCTIONBAR_FUNCTION_WORKOUT,
            itemid: 7,
            itemparam: '',
            status: 100,
            statusmessage: ''
          });
        }
        functionbarbuttons.push({
          description: 'Historie',
          color: buttonColor,
          type: general.FUNCTIONBAR_FUNCTION_HISTORIE,
          itemid: 5,
          itemparm: '',
          status: 100,
          statusmessage: ''
        })
        
        functionbarbuttons.push({
          description: dispatch(dataActions.getTranslation(resource.PRINT_HISTORY)),
          color: buttonColor,
          type: general.FUNCTIONBAR_FUNCTION_ARTICLEREPORT,
          itemid: 8,
          itemparm: '',
          status: 100,
          statusmessage: ''
        })
        functionbarbuttons.push({
          description: dispatch(dataActions.getTranslation(resource.PRINT_OBJECTREPORT)),
          color: buttonColor,
          type: general.FUNCTIONBAR_FUNCTION_OBJECTREPORT,
          itemid: 9,
          itemparm: '',
          status: 100,
          statusmessage: ''
        })
        break;
      default:
        break;
    }
    return functionbarbuttons;
  }
}

function setFunctionBarTypeUnsafe(functionbartype, buttons) {
  return {
    type: types.SET_FUNCTIONBAR_TYPE,
    functionbartype,
    buttons
  }
}

export function setFunctionBarType(functionbartype) {
  return (dispatch, getState) => {
    dispatch(setFunctionBarTypeUnsafe(functionbartype, dispatch(getFunctionBarButtons(functionbartype))));
  }
}

export function updateKeyboardInput(input) {
  return {
    type: types.UPDATE_KEYBOARD_INPUT,
    input: input
  }
}

export function executeOKFunction() {
  return (dispatch, getState) => {
    const okFunction = getState().layoutState.keyboard.functionOk;
    if (okFunction !== null) {
      const inputVal = getState().layoutState.keyboard.input;
      const param = [inputVal];
      
      const extraParams = getState().layoutState.keyboard.functionOkParams;
      if (extraParams !== null && extraParams !== undefined) {
        extraParams.forEach(p => {
          param.push(p);
        });
      }
     
      if (getState().layoutState.keyboard.usedispatch) {
        dispatch(okFunction.apply(this, param));
      } else {
        okFunction.apply(this, param);
      }
    }
  }
}

export function toggleKeyboard(show, inputid, message, functionOk, functionOkParams, usedispatch, input = '', initinput = '') {
  return {
    type: types.TOGGLE_KEYBOARD,
    data: {
      show,
      inputid,
      functionOk,
      functionOkParams,
      message,
      usedispatch,
      input,
      initinput
    }
  }
}

export const clearKeyboard = () => ({
  type: types.CLEAR_KEYBOARD
});

function setCultureUnsafe(culture) {
  return {
    type: types.SET_CULTURE,
    culture
  }
}
export function setCulture(culture) {
  return (dispatch) => {
    dispatch(setCultureUnsafe(culture));
  }
}

function receiveLanguages(json) {
  return {
    type: types.RECEIVE_LANGUAGES,
    json
  }
}

function fetchLanguages() {
  return dispatch => fetch(general.API_URL_GET_LANGUAGES)
    .then(response => response.json())
    .then(json => dispatch(receiveLanguages(json)));
}

export function getLanguages() {
  return (dispatch) => dispatch(fetchLanguages())
}

export function getPaymentKeyAction(keylayoutid) {
  return dispatch => dispatch(fetchPaymentKeyAction(keylayoutid))
}

export function fetchPaymentKeyAction(keylayoutid) {
  const apiUrl = `${general.API_URL_GET_PAYMENT_KEY_LAYOUT_ACTION}/${keylayoutid}`;
  return dispatch => fetch(apiUrl)
    .then(response => response.json())
    .then(json => dispatch(receivePaymentKeyAction(json)));
}

function receivePaymentKeyAction(json) {
  return {
    type: types.SET_PAYMENT_KEY_KEYLAYOUT_GROUP,
    json
  }
}



// WEBPACK FOOTER //
// src/actions/layoutActions.js